import {Parameter, Pdfa} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";

export enum PdfaMode {
	ANALYZE = "analyze",
	CONVERT = "convert"
}

export class PortalPdfa extends Pdfa implements Parameter {
	public mode?: PdfaMode;
	public embedZugferd?: boolean;

	constructor(data: any) {
		super(data);

		this.mode = FunctionHelper.exists(data?.mode) ? data.mode : PdfaMode.ANALYZE;
		this.embedZugferd = FunctionHelper.exists(data?.embedZugferd) ? data.embedZugferd : false;
	}

	public static getModeDefault(): PdfaMode {
		return PdfaMode.ANALYZE;
	}

	public static getEmbedZugferdDefault(): boolean {
		return false;
	}

	public static fromJson(data: any): PortalPdfa {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalPdfa(data);
	}

	public toJson(): any {
		return {
			...super.toJson(),
			'mode': this.mode,
			'embedZugferd': this.embedZugferd
		};
	}

	public clone(): PortalPdfa {
		return PortalPdfa.fromJson(this.toJson());
	}
}